import { render, staticRenderFns } from "./SeveralUsersLinkedToDepartmentError.vue?vue&type=template&id=a0ef687c&scoped=true&lang=pug&"
import script from "./SeveralUsersLinkedToDepartmentError.vue?vue&type=script&lang=ts&"
export * from "./SeveralUsersLinkedToDepartmentError.vue?vue&type=script&lang=ts&"
import style0 from "./SeveralUsersLinkedToDepartmentError.vue?vue&type=style&index=0&id=a0ef687c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ef687c",
  null
  
)

export default component.exports